import { useTranslation } from "react-i18next";
import { Option, TypeEnum } from "models/filterOption";

const useFilterOptionsUtils = () => {
  const { t } = useTranslation();
  const typeofValue = (options, value) => {
    const num = !Number.isNaN(options[1]) ? options[0] : options[1];
    const string = !Number.isNaN(options[1]) ? options[1] : options[0];

    if (value === "label") {
      return string;
    }
    return num;
  };

  const enumOptions = (
    typesArray: Array<
      | { name: string; code: number }
      | { offenceName: string; offenceTypeCode: number }
    >
  ) => {
    return typesArray?.map((options) => {
      const optionFormated = Object.values(options);

      return {
        label: typeofValue(optionFormated, "label"),
        value: typeofValue(optionFormated, "value"),
      };
    });
  };

  const optionsSelectInFormHandler = (enumObj) => {
    const options = Object.entries(enumObj);
    return options.map((option) => {
      return {
        label: t(typeofValue(option, "label") as string),
        value: Number(typeofValue(option, "value")),
      };
    });
  };

  const setFilterOptionsData = (filterOptions: Option[], data) => {
    const updatedOptions = filterOptions.map((option: Option) => {
      const updatedOption = option;

      if ("isVerify" in data && option.field === "isVerify") {
        updatedOption.value = data[option.field];
        updatedOption.isSelected = data[option.field] !== null;
      } else if (data[option.field]) {
        if (option.type === TypeEnum.Date) {
          updatedOption.value = new Date(data[option.field]);
        } else {
          updatedOption.value = data[option.field];
        }
        updatedOption.isSelected = true;
      } else {
        if (option.type === TypeEnum.Date) {
          updatedOption.value = null;
        }
        updatedOption.isSelected = false;
      }

      return updatedOption;
    });

    return updatedOptions;
  };

  return {
    enumOptions,
    optionsSelectInFormHandler,
    setFilterOptionsData,
  };
};

export default useFilterOptionsUtils;
